<template>
    <div class="codics-aonaer-info-aonaer-sys-body">
        <HomeHeader :showlogin.sync="loginDialog"></HomeHeader>
        <HomeFooter></HomeFooter>
        <LoginDialog v-model="loginDialog"></LoginDialog>
        <div class="codics-aonaer-info-aonaer-sys-body-content">
            <div class="codics-aonaer-info-aonaer-sys-body-content-line">
                <div class="codics-aonaer-info-aonaer-sys-body-content-line-card" v-for="(item, index) in boardList"
                    :key="index" :style="{ '--backColor': item.color }">
                    <div class="codics-aonaer-info-aonaer-sys-body-content-line-card-box">
                        <el-image class="codics-aonaer-info-aonaer-sys-body-content-line-card-logo" :src="item.logo_b"
                            fit="cover"></el-image>
                        <el-image
                            class="codics-aonaer-info-aonaer-sys-body-content-line-card-logo codics-aonaer-info-aonaer-sys-body-content-line-card-logo-b"
                            :src="item.logo" fit="cover"></el-image>
                        <div class="codics-aonaer-info-aonaer-sys-body-content-line-card-name">{{ item.name }}</div>
                    </div>
                </div>
            </div>
            <div class="codics-aonaer-info-aonaer-sys-body-content-line" style="height: 165px;">
                <div :class="{ 'codics-aonaer-info-aonaer-sys-body-content-line-item': true, 'codics-aonaer-info-aonaer-sys-body-content-line-item2': index > 0 }"
                    v-for="(item, index) in fucData" :key="index" @click="fucItemClick(item, index)"
                    :style="{ '--backColor': item.color, 'width': '20%' }">
                    <div class="codics-aonaer-info-aonaer-sys-body-content-line-item-card">
                        <div class="codics-aonaer-info-aonaer-sys-body-content-line-item-name">{{ item.name }}</div>
                        <el-image class="codics-aonaer-info-aonaer-sys-body-content-line-item-logo" :src="item.logo_b"
                            fit="fill"></el-image>
                    </div>
                    <div class="codics-aonaer-info-aonaer-sys-body-content-line-item-card2">
                        <el-image class="codics-aonaer-info-aonaer-sys-body-content-line-item-card2-img" :src="item.logo"
                            fit="fill"></el-image>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader';
import HomeFooter from '@/components/HomeFooter';
import LoginDialog from '@/components/LoginDialog';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            boardList: [
                {
                    name: '奥纳尔',
                    logo: 'https://cdn.bosscaigou.com/huayuan/map/logo.svg',
                    logo_b: 'https://cdn.bosscaigou.com/huayuan/map/logo_b.svg',
                    color: 'rgba(234, 91, 24, .55)',
                    url: '#'
                },
                {
                    name: '华誉机械',
                    logo: 'https://cdn.bosscaigou.com/huayuan/map/logo_huayu.svg',
                    logo_b: 'https://cdn.bosscaigou.com/huayuan/map/logo_huayu_b.svg',
                    color: 'rgba(114, 177, 49, .75)',
                    url: '#'
                },
                {
                    name: '万市德',
                    logo: 'https://cdn.bosscaigou.com/huayuan/map/logo_ws.svg',
                    logo_b: 'https://cdn.bosscaigou.com/huayuan/map/logo_ws_b.svg',
                    color: 'rgba(158, 48, 174, .7)',
                    url: '#'
                },
                {
                    name: '飞斯智能',
                    logo: 'https://cdn.bosscaigou.com/huayuan/map/logo_fs.svg',
                    logo_b: 'https://cdn.bosscaigou.com/huayuan/map/logo_fs_b.svg',
                    color: 'rgba(53, 107, 180, .8)',
                    url: '#'
                }
            ],
            loginDialog: false,
            fucData: [
                {
                    name: '集团新闻',
                    logo: 'https://cdn.bosscaigou.com/huayuan/map/xw.svg',
                    logo_b: 'https://cdn.bosscaigou.com/huayuan/map/xw_b.svg',
                    color: 'rgba(87, 70, 174, .7)',
                    url: '#'
                },
                {
                    name: '集团新闻',
                    logo: 'https://cdn.bosscaigou.com/huayuan/map/xw.svg',
                    logo_b: 'https://cdn.bosscaigou.com/huayuan/map/xw_b.svg',
                    color: 'rgba(87, 70, 174, .7)',
                    url: '#'
                },
                {
                    name: '公众号',
                    logo: 'https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/ewm.jpg',
                    logo_b: 'https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/tb2.svg',
                    color: 'rgba(40, 196, 96, .7)',
                    url: '#'
                },
                {
                    name: '视频号',
                    logo: 'https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/sph.jpg',
                    logo_b: 'https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/tb3.svg',
                    color: 'rgba(250, 157, 59, .6)',
                    url: '#'
                },
                {
                    name: '抖音号',
                    logo: 'https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/sph.jpg',
                    logo_b: 'https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/tb4.svg',
                    color: 'rgba(254, 44, 85, .7)',
                    url: '#'
                }
            ]
        }
    },
    methods: {
        jumpToPage(pge) {
            jumpTo(this, pge, {}, {});
        },
        cardItemClick(item) {
            switch (item.name) {
                case 'aonaer':
                    jumpTo(this, '奥纳尔首页', {}, {});
                    break;
            }
        }
    },
    components: {
        HomeHeader,
        HomeFooter,
        LoginDialog
    }
}
</script>

<style>
.codics-aonaer-info-aonaer-sys-body {
    height: 100vh;
    width: 100%;
    position: relative;
    float: left;
    background: url('https://cdn.bosscaigou.com/huayuan/map/yasuo_bj.webp') no-repeat;
    background-size: 100% 100%;
}

.codics-aonaer-info-aonaer-sys-body-content {
    height: 440px;
    width: 100%;
    max-width: 1400px;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
}

.codics-aonaer-info-aonaer-sys-body-content-line {
    height: 275px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-aonaer-sys-body-content-line-card {
    height: 100%;
    width: 25%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 2px;
}

.codics-aonaer-info-aonaer-sys-body-content-line-card-box {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: var(--backColor);
    transition: .4s;
    cursor: pointer;
}

.codics-aonaer-info-aonaer-sys-body-content-line-card-box:hover {
    background: rgba(255, 255, 255, .8);
}

.codics-aonaer-info-aonaer-sys-body-content-line-card-logo {
    height: fit-content;
    width: 55%;
    position: absolute !important;
    margin: auto;
    top: -100px;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;
    transition: .4s;
}

.codics-aonaer-info-aonaer-sys-body-content-line-card-box:hover .codics-aonaer-info-aonaer-sys-body-content-line-card-logo {
    opacity: 0;
}

.codics-aonaer-info-aonaer-sys-body-content-line-card-logo-b {
    opacity: 0;
}

.codics-aonaer-info-aonaer-sys-body-content-line-card-box:hover .codics-aonaer-info-aonaer-sys-body-content-line-card-logo-b {
    opacity: 1 !important;
}

.codics-aonaer-info-aonaer-sys-body-content-line-card-name {
    height: 50px;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: -130px;
    line-height: 50px;
    text-align: center;
    color: #FFF;
    font-size: 22px;
    font-weight: 900;
    transition: .4s;
    user-select: none;
}

.codics-aonaer-info-aonaer-sys-body-content-line-card-box:hover .codics-aonaer-info-aonaer-sys-body-content-line-card-name {
    color: #000;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: var(--backColor);
    transition: .4s;
    cursor: pointer;
    backface-visibility: hidden;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item {
    height: 100%;
    width: 25%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 2px;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item2 {
    transition: .4s;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item-card:hover {
    background: rgba(255, 255, 255, .8);
}

.codics-aonaer-info-aonaer-sys-body-content-line-item:hover .codics-aonaer-info-aonaer-sys-body-content-line-item-name {
    color: #333;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item2:hover .codics-aonaer-info-aonaer-sys-body-content-line-item-card {
    transform: rotateY(180deg);
}

.codics-aonaer-info-aonaer-sys-body-content-line-item2:hover .codics-aonaer-info-aonaer-sys-body-content-line-item-card2 {
    transform: rotateY(360deg);
}

.codics-aonaer-info-aonaer-sys-body-content-line-item-name {
    height: 50px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 40px;
    line-height: 50px;
    text-align: center;
    font-size: 22px;
    font-weight: 900;
    color: #FFF;
    user-select: none;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item-logo {
    height: 80px;
    width: 80px;
    position: absolute !important;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 30px;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item-logo img {
    user-select: none;
    -webkit-user-drag: none;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item-card2 {
    height: calc(100% - 4px);
    width: calc(100% - 4px);
    position: absolute;
    margin: auto;
    left: 2px;
    top: 2px;
    background: rgba(255, 255, 255, .8);
    transition: .4s;
    cursor: pointer;
    backface-visibility: hidden;
    transform: rotateY(180deg);
}

.codics-aonaer-info-aonaer-sys-body-content-line-item-card2-img {
    height: 100px;
    width: 100px;
    position: absolute !important;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.codics-aonaer-info-aonaer-sys-body-content-line-item-card2-img img {
    user-select: none;
    -webkit-user-drag: none;
}
</style>